import { a as allCountries } from '../constants/countryLists-VkPLNM7q.js';

const sanitizeCountries = countryList => countryList.filter(country => allCountries.includes(country));

export { sanitizeCountries as s };
//# sourceMappingURL=sanitizeCountries-DhgiX6xR.js.map
